import type { CountryCode, CountryCodesForRequiredStates } from '../constants/countries';
import { CANADA, INDIA, UNITED_STATES } from '../constants/states';

interface State {
  value: string;
  label: string;
}

export const countryRequiresState = (
  countryCode: CountryCode,
): countryCode is CountryCodesForRequiredStates =>
  countryCode === 'US' || countryCode === 'CA' || countryCode === 'IN';

export const getStateNameFromCode = (stateCode: string, countryCode: CountryCode): string => {
  let state: State | undefined;

  if (countryCode === 'US') {
    state = UNITED_STATES.find((s: State) => s.value === stateCode);
  }

  if (countryCode === 'CA') {
    state = CANADA.find((s: State) => s.value === stateCode);
  }

  if (countryCode === 'IN') {
    state = INDIA.find((s: State) => s.value === stateCode);
  }

  if (state === undefined) {
    return 'unknown';
  }

  return state.label;
};
